import "./atoutsCvTwo.scss"
import ThemeCvDto from "../../../../../api/models/cvTheme"
import CvSkillDto from "../../../../../api/models/cvskill"

interface AtoutsCvTwoProps {
	theme?: ThemeCvDto | null
	cvSkill: CvSkillDto
}

function AtoutsCvTwo({ theme, cvSkill }: AtoutsCvTwoProps) {
	const getAtouts = (): string[] =>
		cvSkill?.poleAtouts?.map(element => element.atout) || []

	const getNotes = (): number[] =>
		cvSkill?.poleAtouts?.map(element => Number(element.note)) || []

	const atouts = getAtouts()
	const notes = getNotes()

	return (
		<div className="atouts-two">
			<div
				className="atouts-two-bg"
				style={{
					backgroundImage: `url("${theme?.imagePrincipale}")`,
				}}
			/>

			<div className="atouts-two-content">
				{atouts.map((atoutText, index) => {
					const note = notes[index] ?? 0
					const width =
						(note / 10) * 95 +
						Number(theme?.objetColorCharteBorder || 0)

					return (
						<div
							className="rectangle-two"
							key={atoutText}
							style={{
								backgroundColor: theme?.objetColorBackground,
								width: `${width}%`,
							}}
						>
							<div className="atout-text-two">{atoutText}</div>
						</div>
					)
				})}
			</div>
		</div>
	)
}

export default AtoutsCvTwo
